(function(){
  var U1="https://cdn.shopify.com/s/files/1/0862/4999/6637/files/ChatGPT_Image_Jun_10_2026_04_32_11_PM.png?width=800";
  var U2="https://cdn.shopify.com/s/files/1/0862/4999/6637/files/ChatGPT_Image_Jun_10_2026_04_03_59_PM.png?width=800";
  var U3="https://cdn.shopify.com/s/files/1/0862/4999/6637/files/ChatGPT_Image_Jun_10_2026_04_33_23_PM.png?width=800";
  var HOWTO={
    "glownest-masca-faciala-led":{
      sub:"Terapie cu lumină LED, acasă, în doar câteva minute. Trei pași simpli pentru un ten luminos.",
      steps:[
        {img:U1,t:"Pregătește",p:"Curăță tenul și asigură-te că este uscat. Opțional, aplică un ser pe bază de apă."},
        {img:U2,t:"Tratează",p:"Așază masca pe față, pornește programul dorit și relaxează-te timp de 10–15 minute."},
        {img:U3,t:"Finalizează",p:"Aplică crema hidratantă pentru a sigila beneficiile luminii. Folosește de 3–5 ori pe săptămână."}
      ]
    }
  };
  // ---- Per-product How-to + scope Beauty-Wand-only content ----
  function scopeContent(){
    var m=location.pathname.match(/\/products\/([^\/?#]+)/);
    var handle=m?m[1]:"";
    var ht=document.querySelector('.dollie-howto');
    if(handle==="beauty-wand"){ return; } // keep baked Beauty Wand content
    var data=HOWTO[handle];
    if(data&&ht){
      var steps=data.steps.map(function(s,i){return '<div class="step"><div class="ph"><img src="'+s.img+'" alt="'+s.t+'" loading="lazy"><span class="num">'+(i+1)+'</span></div><h3>'+s.t+'</h3><p>'+s.p+'</p></div>';}).join('');
      ht.innerHTML='<h2>Cum se folosește</h2><p class="sub">'+data.sub+'</p><div class="steps">'+steps+'</div>';
      var sec=ht.closest('.shopify-section'); if(sec) sec.style.display='';
    } else if(ht){
      var sec2=ht.closest('.shopify-section')||ht.parentElement; if(sec2) sec2.style.display='none';
    }
    // hide Beauty-Wand-specific benefit bullets on every other product
    var ps=document.querySelectorAll('.product-details p, .product-information p');
    for(var i=0;i<ps.length;i++){ var t=ps[i].textContent||''; if(t.indexOf('6 func')>-1 || t.indexOf('singur dispozitiv')>-1){ var w=ps[i].parentElement; if(w) w.style.display='none'; break; } }
  }
  // ---- Mirror the real Yotpo rating into the header rating, per product ----
  function fs(a){var r=Math.round(a);if(r<0)r=0;if(r>5)r=5;return '★★★★★'.slice(0,r)+'☆☆☆☆☆'.slice(0,5-r);}
  function findWidget(){var ws=document.querySelectorAll('[data-yotpo-instance-id]');for(var i=0;i<ws.length;i++){var it=ws[i].innerText||'';if(/Based on\s+[\d,]+\s+review/i.test(it)||/Bazat pe\s+[\d,]+\s+recenz/i.test(it))return ws[i];}return null;}
  function scrollRev(){var w=document.querySelector('[data-yotpo-instance-id]');if(w)w.scrollIntoView({behavior:'smooth',block:'start'});}
  function init(box){
    var link=box.querySelector('.dollie-rating__link'),stars=box.querySelector('.dollie-rating__stars'),txt=box.querySelector('.dollie-rating__text');
    if(link)link.addEventListener('click',function(e){e.preventDefault();scrollRev();});
    var n=0,iv=setInterval(function(){
      n++;var w=findWidget();
      if(w){
        var t=w.innerText||'';
        var cm=t.match(/Based on\s+([\d,]+)\s+review/i)||t.match(/Bazat pe\s+([\d,]+)\s+recenz/i);
        var count=cm?parseInt(cm[1].replace(/,/g,''),10):0;
        var avg=null,ae=w.querySelector('[aria-label*="out of 5"]');
        if(ae){var am=ae.getAttribute('aria-label').match(/([\d.]+)\s*out of 5/);if(am)avg=parseFloat(am[1]);}
        if(avg==null){var tm=t.match(/([\d.]+)\s+Based on/i);if(tm)avg=parseFloat(tm[1]);}
        if(count>0){
          if(avg!=null&&stars)stars.textContent=fs(avg);
          if(txt)txt.innerHTML='<strong>'+(avg!=null?avg.toFixed(1):'')+'</strong> · '+count+' '+(count===1?'recenzie':'recenzii');
          if(link)link.style.display='inline-flex';
        }
        clearInterval(iv);
      }
      if(n>50)clearInterval(iv);
    },300);
  }
  function boot(){ scopeContent(); var b=document.querySelectorAll('.dollie-rating'); for(var i=0;i<b.length;i++)init(b[i]); }
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
})();
